/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SensorTypeOption model module.
* @module model/SensorTypeOption
* @version 2020-12-7
*/
export default class SensorTypeOption {
    /**
    * Constructs a new <code>SensorTypeOption</code>.
    * センサータイプ
    * @alias module:model/SensorTypeOption
    * @class
    * @param id {Number} センサータイプID
    * @param name {String} センサータイプ名
    */

    constructor(id, name) {
        
        
        this['id'] = id;
        this['name'] = name;
        
    }

    /**
    * Constructs a <code>SensorTypeOption</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorTypeOption} obj Optional instance to populate.
    * @return {module:model/SensorTypeOption} The populated <code>SensorTypeOption</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorTypeOption();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
    * センサータイプID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * センサータイプ名
    * @member {String} name
    */
    'name' = undefined;




}
